export const DOCUMENT_TYPES = {
  documentModel: "powerhouse/document-model",
  documentPackage: "powerhouse/package",
  documentEditor: "powerhouse/document-editor",
  documentApp: "powerhouse/app",
  documentSubgraph: "powerhouse/subgraph",
  documentProcessor: "powerhouse/processor",
  documentCodegenProcessor: "powerhouse/codegen-processor",
};
